export const orgType = [
    {
        label: 'Federal Government',
        value: 1
    },
    {
        label: 'State Government',
        value: 2
    },
    {
        label: 'Local Government',
        value: 3
    },
    {
        label: 'Private Company National',
        value: 4
    },
    {
        label: 'Private Company International',
        value: 5
    },
    {
        label: 'National/Local NGO',
        value: 6
    },
    {
        label: 'International NGO',
        value: 7
    },
    {
        label: 'National Financial Institutions',
        value: 8
    },
    {
        label: 'International Financial Institutions',
        value: 9 
    },
    {
        label: 'Private Foundations National',
        value: 10
    },
    {
        label: 'Private Foundations International',
        value: 11
    },
    {
        label: 'Community-Based Organizations (CBOs)',
        value: 12
    },
    {
        label: 'Other',
        value: 'Other'
    },
]

export const Role = [
    { label: 'Viewer', value: 'Viewer' },
    { label: 'Contributor', value: 'Contributor' },
    { label: 'Organization Contributor', value: 'Organization Contributor' },
    { label: 'Organization Admin', value: 'Organization Admin' },
]

export const user_roles = [
    { label: 'Organization Admin', value: 2 },
    // { label: 'Admin', value: 1 },
    { label: 'Organization Contributor', value: 3 },
    { label: 'Contributor', value: 4 },
    { label: 'Researcher', value: 5 },
    // { label: 'Viewer', value: 6 },
    
]
export const organizations = [
    // { label: '', value: 1 },
    { label: 'org1', value: 1 },
    { label: 'org2', value: 2 },
    { label: 'org3', value: 3 },
    { label: 'org4', value: 4 },
]
export const currencyType = [
    {label: 'YEN', value:1},
    {label: 'USD', value:2},
    {label: 'LKR', value:3},
    {label: 'INR', value:4},
]


// ! Expense Management
export const relatedOrganization = [
    {label: 'Values should be set', value : 0},
]

export const fundingSources  = [
    {label: 'Federal Government', value : 1},
    {label: 'State Government', value : 2},
    {label: 'Local Government', value : 3},
    {label: 'Private Company National', value : 4},
    {label: 'Private Company International', value : 5},
    {label: 'National/Local NGO', value : 6},
    {label: 'International NGO', value : 7},
    {label: 'National Financial Institutions', value : 8},
    {label: 'International Financial Institutions', value : 9},
    {label: 'Private Foundations International', value : 10},
    {label: 'Private Foundations National', value : 11},
    {label: 'Bilateral Donor', value : 12},
    {label: 'Multilateral Donor', value : 13},
    {label: 'Community-Based Organizations (CBOs)', value : 14},
    {label: 'Households', value : 15},
    {label: 'Other Public', value : 16},
    {label: 'Other', value : 17},
]

export const projectType = [
    {label : 'National', value : 1},
    {label : 'Other', value : 2},
]

export const projectStatus = [
    {label : 'Not Started', value : 4},
    {label : 'In Progress', value : 3},
    {label : 'On-hold', value : 2},
    {label : 'Completed', value : 1},
]

export const projectProvince = [
    {province : 'Central Province', value : 1},
    {province : 'Eastern Province', value : 2},
    {province : 'North Central Province ', value : 3},
    {province : 'North Western Province', value : 4},
    {province : 'Northern Province', value : 5},
    {province : 'Sabaragamuwa Province', value : 6},
    {province : 'Southern Province', value : 7},
    {province : 'Uva Province', value : 8},
    {province : 'Western Province', value : 9},
]

export const projectDistrict = [
    {district : 'Kandy', districtId : 1, provinceId : 1, province : 'Central Province'},
    {district : 'Matale', districtId : 2, provinceId : 1, province : 'Central Province'},
    {district : 'Nuwara Eliya', districtId : 3, provinceId : 1, province : 'Central Province'},

    {district : 'Ampara', districtId : 4, provinceId : 2, province : 'Eastern Province'},
    {district : 'Batticaloa', districtId : 5, provinceId : 2, province : 'Eastern Province'},
    {district : 'Trincomalee', districtId : 6, provinceId : 2, province : 'Eastern Province'},

    {district : 'Anuradhapura', districtId : 7, provinceId: 3, province : 'North Central Province '},
    {district : 'Polonnaruwa', districtId : 8, provinceId: 3, province : 'North Central Province '},

    {district : 'Kurunegala', districtId : 9, provinceId: 4, province : 'North Western Province'},
    {district : 'Puttalam', districtId : 10, provinceId: 4, province : 'North Western Province'},
    
    {district : 'Jaffna', districtId : 11,  provinceId: 5, province : 'Northern Province',},
    {district : 'Kilinochchi', districtId : 12,  provinceId: 5, province : 'Northern Province',},
    {district : 'Mannar', districtId : 13,  provinceId: 5, province : 'Northern Province',},
    {district : 'Mullaitivu', districtId : 14,  provinceId: 5, province : 'Northern Province',},
    {district : 'Vavuniya', districtId : 15,  provinceId: 5, province : 'Northern Province',},


    {district : 'Kegalle', districtId : 16,  provinceId: 6, province : 'Sabaragamuwa Province'},
    {district : 'Ratnapura', districtId : 17,  provinceId: 6, province : 'Sabaragamuwa Province'},

    {district : 'Galle', districtId : 18,  provinceId: 7, province : 'Southern Province'},
    {district : 'Hambantota', districtId : 19,  provinceId: 7, province : 'Southern Province'},
    {district : 'Matara', districtId : 20,  provinceId: 7, province : 'Southern Province'},

    {district : 'Badulla', districtId : 21,  provinceId:8, province : 'Uva Province'},
    {district : 'Monaragala', districtId : 22,  provinceId:8, province : 'Uva Province'},

    {district : 'Colombo', districtId : 23,  provinceId:9, province : 'Western Province'},
    {district : 'Gampaha', districtId : 24,  provinceId:9, province : 'Western Province'},
    {district : 'Kalutara', districtId : 25,  provinceId:9, province : 'Western Province'},
]

export const projectCity = [
    {label : '', value : 0},
]

export const targetType = [
    {label : 'Values should be set', value : 0},
]

export const goal = [
    {label : 'Values should be set', value : 0},
]

export const target = [
    {label : 'Values should be set', value : 0},
]

export const indicator = [
    {label : 'Values should be set', value : 0},
]

export const expenseCategory = [
    {label : 'Values should be set', value : 0},
]

export const expenseSubCategory = [
    {label : 'Category 1 Sub-category 1', value : 1},
    {label : 'Category 1 Sub-category 2', value : 2},
    {label : 'Category 1 Sub-category 3', value : 3},
    {label : 'Category 1 Sub-category 4', value : 4},
]













